import { createAsyncThunk } from '@reduxjs/toolkit';
import { FeedbacksAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { FEEDBACKS_SLICE_NAME } from './models';
import {
  IChangeFeedbackStatusDTO,
  IDeleteFeedbackDTO,
  IGetFeedbacksDTO,
  IGetFeedbacksResponse,
  IChangeFeedbackStatusResponse,
  IGetNewFeedbacksCountResponse,
} from '@/models/feedback.model';

export const getFeedbacks = createAsyncThunk<
  IGetFeedbacksResponse,
  IGetFeedbacksDTO,
  { serializedErrorType: IApiError }
>(
  `${FEEDBACKS_SLICE_NAME}/getFeedbacks`,
  async (data) => {
    const response = await FeedbacksAPI.getFeedbacks(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getNewFeedbacksCount = createAsyncThunk<
  IGetNewFeedbacksCountResponse,
  void,
  { serializedErrorType: IApiError }
>(
  `${FEEDBACKS_SLICE_NAME}/getNewFeedbacksCount`,
  async () => {
    const response = await FeedbacksAPI.getNewFeedbacksCount();
    return response.data;
  },
  { serializeError: formatApiError },
);

export const changeFeedbackStatus = createAsyncThunk<
  IChangeFeedbackStatusResponse,
  IChangeFeedbackStatusDTO,
  { serializedErrorType: IApiError }
>(
  `${FEEDBACKS_SLICE_NAME}/changeFeedbackStatus`,
  async (data, { dispatch }) => {
    const response = await FeedbacksAPI.changeFeedbackStatus(data);
    await dispatch(getNewFeedbacksCount());
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deleteFeedback = createAsyncThunk<void, IDeleteFeedbackDTO, { serializedErrorType: IApiError }>(
  `${FEEDBACKS_SLICE_NAME}/deleteFeedback`,
  async (data) => {
    await FeedbacksAPI.deleteFeedback(data);
  },
  { serializeError: formatApiError },
);
